import { getUnreadBroadcasts } from "./notificationReads";

function occurrenceSortKey(item) {
  if (item.is_today) return 0;
  if (item.is_tomorrow) return 1;
  return 2;
}

function compareBroadcasts(a, b) {
  const dayDiff = occurrenceSortKey(a) - occurrenceSortKey(b);
  if (dayDiff !== 0) return dayDiff;

  const dateDiff = String(a.occurrence_at || "").localeCompare(String(b.occurrence_at || ""));
  if (dateDiff !== 0) return dateDiff;

  const eventDiff = String(a.event_id || "").localeCompare(String(b.event_id || ""));
  if (eventDiff !== 0) return eventDiff;

  return String(b.created_at || "").localeCompare(String(a.created_at || ""));
}

export function sortBroadcasts(broadcasts) {
  return [...(broadcasts || [])].sort(compareBroadcasts);
}

export function pickPriorityBroadcast(broadcasts) {
  const unread = getUnreadBroadcasts(broadcasts);
  if (!unread.length) return null;
  return sortBroadcasts(unread)[0];
}

export function groupBroadcastsByOccurrence(broadcasts) {
  const sorted = sortBroadcasts(broadcasts);
  const groups = [];
  let current = null;

  for (const item of sorted) {
    const key = `${item.event_id}:${item.occurrence_date}`;
    if (!current || current.key !== key) {
      current = {
        key,
        event_id: item.event_id,
        event_name: item.event_name,
        cover_color: item.cover_color,
        occurrence_date: item.occurrence_date,
        occurrence_at: item.occurrence_at,
        is_today: item.is_today,
        is_tomorrow: item.is_tomorrow,
        items: [],
      };
      groups.push(current);
    }
    current.items.push(item);
  }

  return groups;
}

export function sectionLabelForGroup(group) {
  if (group.is_today) return "Today";
  if (group.is_tomorrow) return "Tomorrow";
  if (group.occurrence_at) {
    const d = new Date(group.occurrence_at);
    if (!Number.isNaN(d.getTime())) {
      return d.toLocaleDateString(undefined, { weekday: "long", day: "numeric", month: "short" });
    }
  }
  if (!group.occurrence_date && !group.event_id) {
    return group.event_name || "Updates";
  }
  return group.occurrence_date || "Upcoming";
}
